import { useEffect, useState } from "react";
import HandlerRadio from "components/CustomRadio/CustomRadio";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { Column, Row } from "components/styles";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import { RADIO_BOOL_OPTIONS } from "../Popups/AppointmentData/utils/constants";
import CustomButton from "components/CustomButton/CustomButton";
import { requestSaveSession, requestUpdateSession } from "services/appointment/aboutAppoinment";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import Preloader from "components/Preloader/Preloader";
import { CUSTOM_BUTTON_PROPS } from "views/components/AttendanceList/TakeTeacherAttendancePanel/constants";
import DatePicker from "components/DatePicker/DatePicker";
import useMainContext from "utils/context/useMainContext";
import useScheduleComponentContext from "../../../SchedulesComponent/utils/context/useScheduleComponentContext";

const SessionAppointment = ({reservation, session, reasons, duration}) => {
    const mainContext = useMainContext();
    const { changeReservationAttendance } = useScheduleComponentContext();
    const [isNewSession, setIsNewSession] = useState(false)
    const [loading, setLoading] = useState(false);
    const [selectReason, setSelectReason] = useState(null);
    const [otherReason, setOtherReason] = useState(null);
    const [checkOptionFollow, setCheckOptionFollow] = useState(null);
    const [checkOptionCodeBlue, setCheckOptionCodeBlue] = useState(null);
    const [checkOptionAttendance, setCheckOptionAttendance] = useState(null);
    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);
    const [errorSelectReason, setErrorSelectReason] = useState(false);
    const [errorOtherReason, setErrorOtherReason] = useState(false);
    const [errorOptionFollow, setErrorOptionFollow] = useState(false);
    const [errorOptionCodeBlue, setErrorOptionCodeBlue] = useState(false);
    const [errorOptionAttendance, setErrorOptionAttendance] = useState(false);
    const [responseSave, setResponseSave] = useState(false);

    useEffect(() => {
        if(!session){
            setIsNewSession(true);
            setCheckIn(`${duration}:00:00`);
            setCheckOut(`${duration + 1}:00:00`);
            return;
        }
        setIsNewSession(false);
        setOtherReason(session.otroMotivo);
        setSelectReason(session.idMotivo);
        setCheckOptionFollow(session.seguimiento);
        setCheckOptionCodeBlue(session.codigoAzul);
        setCheckOptionAttendance(session.asistencia);
        setCheckIn(formatTime(session.horaInicio));
        setCheckOut(formatTime(session.horaFin));
    }, [session, duration])

    const formatTime = (time) =>{
        return time.split('T')[1];
    }
    const handleOtherReason = (val) =>{
        setOtherReason(val)
        setErrorOtherReason(false)
    }

    const handlerSelectReason = (value) => {
        setErrorSelectReason(false);
        setErrorOtherReason(false);
        if(selectReason === 21 && value !== 21){
            setOtherReason(null);
        }
        setSelectReason(value)
    }

    const handleCheckOptionFollow = (value) => {
        setErrorOptionFollow(false)
        setCheckOptionFollow(value)
    }

    const handleCheckOptionCodeBlue = (value) => {
        setErrorOptionCodeBlue(false)
        setCheckOptionCodeBlue(value)
    }

    const handleCheckOptionAttendance = (value) => {
        setErrorOptionAttendance(false)
        setCheckOptionAttendance(value)
    }

    const saveSession = async () => {
        let response = null;

        if(selectReason === null){
            setErrorSelectReason(true)
        }
        if(selectReason === 21 && otherReason === null){
            setErrorOtherReason(true);
        }
        if(checkOptionFollow === null){
            setErrorOptionFollow(true)
        }
        if(checkOptionCodeBlue === null){
            setErrorOptionCodeBlue(true)
        }
        if(checkOptionAttendance === null){
            setErrorOptionAttendance(true)
        }

        if(selectReason === null || (selectReason === 21 && otherReason === null) || checkOptionFollow === null || checkOptionCodeBlue === null || checkOptionAttendance === null){
            return;
        }

        const request = {
            idReservaAsesoria: reservation.id,
            idMotivo: selectReason,
            otroMotivo: otherReason,
            seguimiento: checkOptionFollow,
            codigoAzul: checkOptionCodeBlue,
            asistencia: checkOptionAttendance,
            horaInicio: checkIn || null,
            horaFin: checkOut || null
        }

        setLoading(true);
        if(isNewSession){
            response = await requestSaveSession(request);
            if(response === 1){
                setResponseSave(true);
            } else {
                setResponseSave(false);
                mainContext.setShowDialogUnexpectedError(true);
                return;
            }
        } else {
            response = await requestUpdateSession(request);
            if(response !== 1){
                mainContext.setShowDialogUnexpectedError(true);
                return;
            }
        }
        changeReservationAttendance(reservation.id, checkOptionAttendance);
        setLoading(false);
        setResponseSave(response);
    }

    return (
        <Column marginTop="6px">
            <Row width="100%" gap="15px" wrap="nowrap">
                <div style={{ flex: 1 }}>
                    <DatePicker
                        textData="Hora de entrada:"
                        value={checkIn}
                        setValue={setCheckIn}
                        data={session}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <DatePicker
                        textData="Hora de salida:"
                        value={checkOut}
                        setValue={setCheckOut}
                        data={session}
                    />
                </div>
            </Row>

            <Row width="100%" gap="15px" wrap="nowrap">
                <div style={{ flex: 1 }}>
                    <TextData> Seleccionar motivo de la sesión</TextData>
                    <CustomSelect
                        optionsProps={reasons || []}
                        onChange={value => handlerSelectReason(value)}
                        value = {selectReason}
                        disabled = {loading}
                        error={errorSelectReason}
                        errorText={errorSelectReason && `Seleccionar este campo`}
                    />
                </div>
            
                { (selectReason === 21) &&
                <div style={{ flex: 1 }}>
                    <TextData>Ingresa otro motivo</TextData>
                    <CustomTextInput
                        placeholder="Texto mostrado (max. 50 carac.)"
                        value={otherReason || ''}
                        onChange={handleOtherReason}
                        maxLength={50}
                        error={errorOtherReason}
                        errorText={errorOtherReason && `Completar este campo`}
                    />
                </div>
                }
            </Row>

            <Row justifyContent="flex-start" width="100%">
                <div>
                    <TextData>¿Asistió el estudiante?</TextData>
                    <HandlerRadio 
                        radiosProps={RADIO_BOOL_OPTIONS}
                        value={checkOptionAttendance}
                        onChange={handleCheckOptionAttendance}
                        gap='35px'
                        error={errorOptionAttendance}
                        errorText={errorOptionAttendance && "Seleccionar opción"}
                        marginTop="8px"/>
                </div>

                <div>
                    <TextData>¿Requiere de seguimiento?</TextData>
                    <HandlerRadio 
                        radiosProps={RADIO_BOOL_OPTIONS}
                        value={checkOptionFollow}
                        onChange={handleCheckOptionFollow}
                        gap='35px'
                        error={errorOptionFollow}
                        errorText={errorOptionFollow && "Seleccionar opción"}
                        marginTop="8px"/>
                </div>
                <div>
                    <TextData>¿Es de código azul?</TextData>
                    <HandlerRadio 
                        radiosProps={RADIO_BOOL_OPTIONS}
                        value={checkOptionCodeBlue}
                        onChange={handleCheckOptionCodeBlue}
                        gap='35px'
                        error={errorOptionCodeBlue}
                        errorText={errorOptionCodeBlue && "Seleccionar opción"}
                        marginTop="8px"/>
                </div>
            </Row>

            {
                isNewSession
                ? <CustomButton
                        {...CUSTOM_BUTTON_PROPS}
                        size="medium"
                        width="83px"
                        text="Guardar"
                        onClick={saveSession}
                        disabled={responseSave}
                    />
                : <CustomButton
                        {...CUSTOM_BUTTON_PROPS}
                        size="medium"
                        width="83px"
                        text="Editar"
                        onClick={saveSession}
                    />
            }

            <Preloader
                hidden={!loading} 
                message={"Guardando"}/>
        </Column>
    )
}

export default SessionAppointment;
